var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClassicLayout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "#f8f9fa",
    rx: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#e9ecef"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 160,
    height: 30,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 55,
    width: 160,
    height: 15,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 85,
    width: 160,
    height: 30,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 120,
    width: 160,
    height: 15,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 150,
    width: 160,
    height: 30,
    rx: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassicLayout);
export default __webpack_public_path__ + "static/media/classic-layout.1d5c9c21256bcb3e60d8805f12031f93.svg";
export { ForwardRef as ReactComponent };